// eslint-disable-next-line max-classes-per-file
import { Named } from '../base/named';
import { ChildResourceNamed } from '../base/child-resource-named';
import { DatabaseEntity } from '../database/databaseEntity';

export interface IIdentityProvider {
    /*
        Identity of the named
    */
    identity(named: Named): string;

    /*
        Name of the resource
    */
    name(resource: {}): string | undefined;
}

/*
    Use this as the default identity provider
*/
export class DefaultIdentityProvider implements IIdentityProvider {

    public static instance: DefaultIdentityProvider = new DefaultIdentityProvider();

    // eslint-disable-next-line brace-style
    private constructor() { }
    /*
        Identity of the named
    */
    public identity(named: Named): string {
        return named.name ? named.name : '';
    }

    public name(resource: {}): string | undefined {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (resource as any).name;
    }
}

export class ARMTemplateIdentityProvider implements IIdentityProvider {

    public static readonly instance = new ARMTemplateIdentityProvider();

    // eslint-disable-next-line brace-style
    private constructor() { }
    /*
        Identity of the named
    */
    public identity(named: Named): string {
        if (named instanceof ChildResourceNamed && named.parentResource) {
            return `${named.parentResource.name}/${named.name}`;
        }
        if (named instanceof DatabaseEntity && named.parentInfo) {
            return `${named.parentInfo.resourceName}/${named.realName}`;
        }
        return DefaultIdentityProvider.instance.identity(named);
    }

    public name(resource: {}): string | undefined {
        return DefaultIdentityProvider.instance.name(resource);
    }
}
